var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import theme from '../theme';
var FileDrop = function (_a) {
    var onDrop = _a.onDrop;
    var _b = useDropzone({ onDrop: onDrop }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    return (React.createElement(FileDropWrapper, __assign({ elevation: 3 }, getRootProps()),
        React.createElement("input", __assign({}, getInputProps())),
        isDragActive ? (React.createElement(React.Fragment, null,
            React.createElement(AttachFileIcon, null),
            React.createElement("p", null, "Drop the files here"))) : (React.createElement(React.Fragment, null,
            React.createElement(AttachFileIcon, null),
            React.createElement("p", null, "Drag & drop some files here, or click to select files")))));
};
var FileDropWrapper = withStyles({
    root: {
        color: theme.palette.text.primary,
        margin: 16,
        padding: 24,
        cursor: 'pointer',
        display: 'inline-flex',
        alignSelf: 'center',
        alignItems: 'center',
    },
    '& svg': {
        width: '1em',
    },
})(Paper);
export default FileDrop;
